import './ORGANIZATION_LOGO_NAME_WidgetLayout.css';

import { Box } from '@mui/material';
import { fullImagePath } from '../../../../b2b-common/helpers';
import Banner from '../../../../b2b-common/Banner';

const ORGANIZATION_LOGO_NAME_WidgetLayout = ({ logoSize, widgetLayout = 'logo_name', organizationName, organizationImage }) => {
    const headingLevel = logoSize > 200 ? 'h1' : logoSize > 100 ? 'h2' : 'h3';
    return (
        <Box className='OrgLogoNameWidget-container'
            display={'flex'} justifyContent={'center'} alignItems={'center'}
            flexDirection={widgetLayout === 'logo_only' ? 'column' : 'row'}
            gap={0} boxSizing={'border-box'}
            height={`${logoSize}px`} width={widgetLayout === 'logo_only' ? `${logoSize}px` : 'auto'}
            padding={widgetLayout === 'logo_only' ? '0px 0px' : '0px 10px'}
        >
            <img
                alt={organizationName}
                src={fullImagePath(organizationImage)}
                className='OrgLogoNameWidget-image'
                style={{ width: `${logoSize}px`, height: `${logoSize}px`, borderRadius: '50%' }}
            />
            {widgetLayout === 'logo_name' && (
                <Box className='OrgLogoNameWidget-name'>
                    <Banner message={organizationName} underline={false} headingLevel={headingLevel} />
                </Box>
            )}
        </Box>
    );
}

export default ORGANIZATION_LOGO_NAME_WidgetLayout;